import platform from '@propertypal/shared/src/utils/platform';
import styled from 'styled-components';

export const Label = styled.label`
  display: block;
  color: ${(props) => props.theme.textDark};
  font-size: 16px;
  font-weight: 600;
  margin-bottom: 10px;
  padding-left: ${platform.select(18, 0)}px;
`;

export const AreaInput = styled.textarea<{ error?: false | string; borderColour?: string }>`
  display: block;
  background: ${(props) => props.theme.background};
  color: ${(props) => (props.disabled ? props.theme.backgroundMid : props.theme.textDark)};
  font-size: 16px;
  padding: ${platform.select(18, 15)}px;
  margin: 0;
  box-shadow: inset 0 0 0
    ${(props) => (props.error ? `2px ${props.theme.primary}` : `1px ${props.borderColour || props.theme.keyline}`)};
  border: none;
  min-width: 0;
  width: 100%;
  -webkit-appearance: none;
  resize: none;
  font-family: inherit;
  border-radius: ${platform.select(18, 6)}px;

  &::placeholder {
    color: ${(props) => props.theme.backgroundMid};
  }
`;
